import { render, staticRenderFns } from "./customChart.vue?vue&type=template&id=32a40fd0&scoped=true&"
import script from "./customChart.vue?vue&type=script&lang=js&"
export * from "./customChart.vue?vue&type=script&lang=js&"
import style0 from "./customChart.vue?vue&type=style&index=0&id=32a40fd0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a40fd0",
  null
  
)

export default component.exports